var scope_0 = require('/mnt/d/ShapeGanicGatsby/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0d456af5f09afd1377ca14c63e3db545.js').default;
var scope_1 = require('/mnt/d/ShapeGanicGatsby/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/300b093ef7394bea1c088e15f8078e90.js').default;
var scope_2 = require('/mnt/d/ShapeGanicGatsby/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/76115b7762ad9d47d6fd4ac206f0a539.js').default;
var scope_3 = require('/mnt/d/ShapeGanicGatsby/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/85fb3f91374d7ef403db1579cd393051.js').default;
var scope_4 = require('/mnt/d/ShapeGanicGatsby/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b1604acd9d7d1516dea16791bf7a6953.js').default;
var scope_5 = require('/mnt/d/ShapeGanicGatsby/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b7e3762f217ce64ee69903b7f810904c.js').default;
var scope_6 = require('/mnt/d/ShapeGanicGatsby/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ea87fa1db88014b65cebbce76982eb8a.js').default;
var scope_7 = require('/mnt/d/ShapeGanicGatsby/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ee73ed2a72de2995590f4ed4e5415686.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6,
scope_7 )
    